<template>
  <div class="hidden-area-content" v-if="hiddenAreaToDisplay?.question && hiddenarea?.length" @click="showErrorMessage">
    <div class="hidden-area" :style="hiddenAreaToDisplay.style" @click="hideHiddenArea"></div>
    <div class="question-wrapper" v-if="hiddenAreaToDisplay.question">
      <div class="question-container">{{ hiddenAreaToDisplay.question }}</div>
    </div>
    <div class="error-message-wrapper" v-if="errorMessage">
      <div class="error-message-container">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "interacitive-hiddenarea",
  components: {},
  props: {
    player: {
      required: true,
      type: Object,
    },
  },
  computed: {
    hiddenarea() {
      return this.setVideoInfos?.interactivityOptions?.data?.interactivity?.filter((inter) => inter.type == "hidden-area"
      );
    },
    ...mapGetters(['getCurrentTime', 'setVideoInfos'])
  },
  data() {
    return {
      hiddenAreaToDisplay: {},
      errorMessage: "",
      currentT: 0,
    };
  },
  watch: {
    hiddenarea: {
      deep: true,
      handler(newHiddenArea) {
        if (!newHiddenArea || newHiddenArea.length === 0) {
          this.clearHiddenAreaData();
        }

      },
    },
    player: {
      handler() {
        this.player.on("timeupdate", () => {
          const currentTime = Math.round(this.player.currentTime());
          this.hiddenarea?.forEach((item) => {
            const startItem = item.start;
            if (startItem && currentTime === startItem && this.currentT != startItem) {
              this.currentT = startItem;
              this.hiddenAreaToDisplay = item;
              this.updateHAsPosition();
              this.player.pause();
            }
          });
          this.currentT = currentTime;
        });
      },
      deep: true,
    },
  },
  methods: {
    clearHiddenAreaData() {
      this.hiddenAreaToDisplay = {};
      this.errorMessage = "";
      this.currentT = 0;
      const videoElement = document.querySelector(".vjs-tech");
      videoElement.style.zIndex = "auto";
    },
    updateHAsPosition() {
      const videoElement = document.querySelector(".vjs-tech");
      const videoElStyle = window.getComputedStyle(videoElement);
      videoElement.style.zIndex = "99999";
      let actualTopValue = 0;
      const viHeight = this._getFloatStyle(videoElStyle.height);
      if (this._getFloatStyle(videoElStyle.top) != 0) {
        actualTopValue = this._getFloatStyle(videoElStyle.top) - viHeight / 2;
      }
      if (
        this.hiddenAreaToDisplay.width &&
        this.hiddenAreaToDisplay.height &&
        this.hiddenAreaToDisplay.position_y &&
        this.hiddenAreaToDisplay.position_x
      ) {
        this.hiddenAreaToDisplay.style = {
          width: (+this.hiddenAreaToDisplay.width) + "%",
          height: (+this.hiddenAreaToDisplay.height) + "%",
          top:
            actualTopValue +
            (+this.hiddenAreaToDisplay.position_y) +
            "%",
          left:
            this._getFloatStyle(videoElStyle.left) +
            (+this.hiddenAreaToDisplay.position_x) +
            "%",
        };
      }
    },
    _getFloatStyle(style) {
      return +style?.substring(0, style.length - 2);
    },
    showErrorMessage() {
      this.errorMessage = this.hiddenAreaToDisplay?.message || "";
    },
    hideHiddenArea() {
      const videoElement = document.querySelector(".vjs-tech");
      videoElement.style.zIndex = "auto";
      this.player.play();
      this.hiddenAreaToDisplay = {};
    },
  },
});
</script>

<style>
.hidden-area-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
}

.hidden-area-content .hidden-area {
  position: absolute;
  z-index: 1;
}

.hidden-area-content .error-message-wrapper {
  position: absolute;
  bottom: 3em;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
}

.hidden-area-content .error-message-wrapper .error-message-container {
  background-color: var(--vm-color-one-06) ;
  color: var(--vm-color-three);
  padding: 0.5em 2em;
  border-radius: 0.2em;
  font-size: 1.2em;
}

.hidden-area-content .question-wrapper {
  position: absolute;
  top: 3em;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
}

.hidden-area-content .question-wrapper .question-container {
  background-color: var(--vm-color-one-06) ;
  color: var(--vm-color-three);
  padding: 0.5em 2em;
  border-radius: 0.2em;
  font-size: 1.2em;
}

#hidden-area-wrapper.vjs-navigation-container-visible .hidden-area {
  margin-left: 25%;
  transform: scale(0.75);
  transform-origin: top left;
  transition: 0.5s ease;
}
</style>
